import React, { FunctionComponent, DetailedHTMLProps, ButtonHTMLAttributes } from 'react';

import './SmallButton.scss';

export const SmallButton: FunctionComponent<
    DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
> = (props) => {
    const augmentedProps = {
        ...props,
        className: [props.className, 'shopping-planner-small-button'].join(' '),
        type: props.type ?? 'button',
    };

    return <button {...augmentedProps}>{props.children}</button>;
};
